import React from 'react';
import { IconProps } from './model/IconInterface';

const BuildingIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <rect x='5' y='3' width='14' height='18' rx='1' />
        <line x1='3' y1='21' x2='21' y2='21' />
        <line x1='9' y1='7' x2='9.01' y2='7' />
        <line x1='15' y1='7' x2='15.01' y2='7' />
        <line x1='9' y1='11' x2='9.01' y2='11' />
        <line x1='15' y1='11' x2='15.01' y2='11' />
        <path d='M10 21v-3a2 2 0 0 1 4 0v3' />
    </svg>
);

export default BuildingIcon;
